import { APP_SET_TOKEN,
  APP_SET_GROUP,
  APP_SET_RESET_PASSWORD_REQUIRED,
  APP_SET_RESET_PASSWORD_LINK,
  APP_SET_SEASON,
  APP_SET_SEASON_IDENTIFIER,
  APP_SET_SEASON_YEAR,
  APP_SET_EMPLOYEE_PERMISSIONS,
  APP_SET_USER_EMAIL,
  APP_SET_OL_ORDER_FILTERS,
  APP_SET_OL_ORDER_HIDDEN_COLUMNS,
  APP_SET_OL_ORDER_SEARCH_FIELDS,
  APP_SET_OL_ORDER_COLUMNS_WIDTH,
  APP_SET_OL_ORDER_COLUMNS_SEQUENCE,
  APP_SET_ZS_ORDER_FILTERS,
  APP_SET_ZS_ORDER_HIDDEN_COLUMNS,
  APP_SET_ZS_ORDER_SEARCH_FIELDS,
  APP_SET_ZS_ORDER_COLUMNS_WIDTH,
  APP_SET_ZS_ORDER_COLUMNS_SEQUENCE,
  APP_SET_PL_ORDER_FILTERS,
  APP_SET_PL_ORDER_HIDDEN_COLUMNS,
  APP_SET_PL_ORDER_SEARCH_FIELDS,
  APP_SET_PL_ORDER_COLUMNS_WIDTH,
  APP_SET_PL_ORDER_COLUMNS_SEQUENCE,
  APP_SET_EMPLOYEE_COLUMNS_WIDTH,
  APP_SET_EMPLOYEE_COLUMNS_SEQUENCE,
  APP_SET_EMPLOYEE_APPLICATION_COLUMNS_WIDTH,
  APP_SET_EMPLOYEE_APPLICATION_COLUMNS_SEQUENCE,
  APP_SET_WR_ORDER_FILTERS,
  APP_SET_WR_ORDER_HIDDEN_COLUMNS,
  APP_SET_WR_ORDER_SEARCH_FIELDS,
  APP_SET_WR_ORDER_COLUMNS_WIDTH,
  APP_SET_WR_ORDER_COLUMNS_SEQUENCE,
  APP_SET_ORDER,
  APP_UPDATE_ORDER,
  APP_DELETE_ORDER,
  APP_SET_MODULE,
  APP_ALLOW_AUTO_ORDER_UPDATE,
  APP_SET_EMPLOYEE_ID,
  APP_SET_EMPLOYEE_CONFIG_ID,
  APP_SET_EXTERNAL_ORDER_ID,
  REACT_APP_VERSION } from './redux-actions';
import { getOrderColumns } from './functions';
import { EmployeesColumns, ApplicationsColumns } from './column-definitions';

export const appReducer = (
  state = {
    token: null,
    group: null,
    resetPasswordRequired: false,
    resetPasswordLink: '',
    season: '',
    seasonIdentifier: '',
    seasonYear: '',
    module: '',
    allowAutoOrderUpdate: true,
    employeeId: null,
    employeeConfigId: null,
    version: process.env.REACT_APP_VERSION,
    employeePermissions: []
  },
  action
) => {
  switch (action.type) {
  case REACT_APP_VERSION:
    return {
      ...state,
      version: action.payload
    };
  case APP_SET_TOKEN:
    return {
      ...state,
      token: action.payload
    };
  case APP_SET_GROUP:
    return {
      ...state,
      group: action.payload
    };
  case APP_SET_RESET_PASSWORD_REQUIRED:
    return {
      ...state,
      resetPasswordRequired: action.payload
    };
  case APP_SET_RESET_PASSWORD_LINK:
    return {
      ...state,
      resetPasswordLink: action.payload
    };
  case APP_SET_EMPLOYEE_PERMISSIONS:
    return {
      ...state,
      employeePermissions: action.payload
    };
  case APP_SET_SEASON:
    return {
      ...state,
      season: action.payload
    };
  case APP_SET_SEASON_IDENTIFIER:
    return {
      ...state,
      seasonIdentifier: action.payload
    };
  case APP_SET_SEASON_YEAR:
    return {
      ...state,
      seasonYear: action.payload
    };
  case APP_SET_USER_EMAIL:
    return {
      ...state,
      userEmail: action.payload
    };
  case APP_SET_MODULE:
    return {
      ...state,
      module: action.payload
    };
  case APP_ALLOW_AUTO_ORDER_UPDATE:
    return {
      ...state,
      allowAutoOrderUpdate: action.payload
    };
  case APP_SET_EMPLOYEE_ID:
    return {
      ...state,
      employeeId: action.payload
    };
  case APP_SET_EMPLOYEE_CONFIG_ID:
    return {
      ...state,
      employeeConfigId: action.payload
    };
  default:
    return state;
  }
};

export const employeeOrderConfigReducer = (
  state = {
    olOrderColumnsWidth: [],
    olOrderFilters: [],
    olOrderHiddenColumns: [],
    olOrderSearchFields: { main: getOrderColumns('obozy').slice(1)
      .map(obj => obj.field) },
    olOrderColumnsSequence: { main: getOrderColumns('obozy').slice(1)
      .map(obj => obj.field) },
    zsOrderColumnsWidth: [],
    zsOrderFilters: [],
    zsOrderHiddenColumns: [],
    zsOrderSearchFields: { main: getOrderColumns('zielone_szkoly').slice(1)
      .map(obj => obj.field) },
    zsOrderColumnsSequence: { main: getOrderColumns('zielone_szkoly').slice(1)
      .map(obj => obj.field) },
    plOrderColumnsWidth: [],
    plOrderFilters: [],
    plOrderHiddenColumns: [],
    plOrderSearchFields: { main: getOrderColumns('polkolonie').slice(1)
      .map(obj => obj.field) },
    plOrderColumnsSequence: { main: getOrderColumns('polkolonie').slice(1)
      .map(obj => obj.field) },
    wrOrderColumnsWidth: [],
    wrOrderFilters: [],
    wrOrderHiddenColumns: [],
    wrOrderSearchFields: { main: getOrderColumns('wyjazdy_rodzinne').slice(1)
      .map(obj => obj.field) },
    wrOrderColumnsSequence: { main: getOrderColumns('wyjazdy_rodzinne').slice(1)
      .map(obj => obj.field) }

  },
  action
) => {
  switch (action.type) {
  case APP_SET_OL_ORDER_COLUMNS_WIDTH:
    return {
      ...state,
      olOrderColumnsWidth: {
        ...state.olOrderColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_OL_ORDER_FILTERS:
    return {
      ...state,
      olOrderFilters: {
        ...state.olOrderFilters,
        ...action.payload
      }
    };
  case APP_SET_OL_ORDER_HIDDEN_COLUMNS:
    return {
      ...state,
      olOrderHiddenColumns: {
        ...state.olOrderHiddenColumns,
        ...action.payload
      }
    };
  case APP_SET_OL_ORDER_SEARCH_FIELDS:
    return {
      ...state,
      olOrderSearchFields: {
        ...state.olOrderSearchFields,
        ...action.payload
      }
    };
  case APP_SET_OL_ORDER_COLUMNS_SEQUENCE:
    return {
      ...state,
      olOrderColumnsSequence: {
        ...state.olOrderColumnsSequence,
        ...action.payload
      }
    };
  case APP_SET_ZS_ORDER_COLUMNS_WIDTH:
    return {
      ...state,
      zsOrderColumnsWidth: {
        ...state.zsOrderColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_ZS_ORDER_FILTERS:
    return {
      ...state,
      zsOrderFilters: {
        ...state.zsOrderFilters,
        ...action.payload
      }
    };
  case APP_SET_ZS_ORDER_HIDDEN_COLUMNS:
    return {
      ...state,
      zsOrderHiddenColumns: {
        ...state.zsOrderHiddenColumns,
        ...action.payload
      }
    };
  case APP_SET_ZS_ORDER_SEARCH_FIELDS:
    return {
      ...state,
      zsOrderSearchFields: {
        ...state.zsOrderSearchFields,
        ...action.payload
      }
    };
  case APP_SET_ZS_ORDER_COLUMNS_SEQUENCE:
    return {
      ...state,
      zsOrderColumnsSequence: {
        ...state.zsOrderColumnsSequence,
        ...action.payload
      }
    };
  case APP_SET_PL_ORDER_COLUMNS_WIDTH:
    return {
      ...state,
      plOrderColumnsWidth: {
        ...state.plOrderColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_PL_ORDER_FILTERS:
    return {
      ...state,
      plOrderFilters: {
        ...state.plOrderFilters,
        ...action.payload
      }
    };
  case APP_SET_PL_ORDER_HIDDEN_COLUMNS:
    return {
      ...state,
      plOrderHiddenColumns: {
        ...state.plOrderHiddenColumns,
        ...action.payload
      }
    };
  case APP_SET_PL_ORDER_SEARCH_FIELDS:
    return {
      ...state,
      plOrderSearchFields: {
        ...state.plOrderSearchFields,
        ...action.payload
      }
    };
  case APP_SET_PL_ORDER_COLUMNS_SEQUENCE:
    return {
      ...state,
      plOrderColumnsSequence: {
        ...state.plOrderColumnsSequence,
        ...action.payload
      }
    };
  case APP_SET_WR_ORDER_COLUMNS_WIDTH:
    return {
      ...state,
      wrOrderColumnsWidth: {
        ...state.wrOrderColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_WR_ORDER_FILTERS:
    return {
      ...state,
      wrOrderFilters: {
        ...state.wrOrderFilters,
        ...action.payload
      }
    };
  case APP_SET_WR_ORDER_HIDDEN_COLUMNS:
    return {
      ...state,
      wrOrderHiddenColumns: {
        ...state.wrOrderHiddenColumns,
        ...action.payload
      }
    };
  case APP_SET_WR_ORDER_SEARCH_FIELDS:
    return {
      ...state,
      wrOrderSearchFields: {
        ...state.wrOrderSearchFields,
        ...action.payload
      }
    };
  case APP_SET_WR_ORDER_COLUMNS_SEQUENCE:
    return {
      ...state,
      wrOrderColumnsSequence: {
        ...state.wrOrderColumnsSequence,
        ...action.payload
      }
    };
  default:
    return state;
  }
};

export const orderDataReducer = (
  state = {
    order: {},
    externalOrderId: null
  },
  action
) => {
  switch (action.type) {
  case APP_SET_ORDER:
    return {
      ...state,
      order: action.payload
    };
  case APP_UPDATE_ORDER:
    return {
      ...state,
      order: action.payload
    };
  case APP_DELETE_ORDER:
    return {
      ...state,
      order: {}
    };
  case APP_SET_EXTERNAL_ORDER_ID:
    return {
      ...state,
      externalOrderId: action.payload
    };
  default:
    return state;
  }
};

export const employeeRecruitmentConfigReducer = (
  state = {
    eColumnsWidth: [],
    eColumnsSequence: [...EmployeesColumns().map(obj => obj.field)],
    eaColumnsWidth: [],
    eaColumnsSequence: [...ApplicationsColumns().map(obj => obj.field)]
  },
  action
) => {
  switch (action.type) {
  case APP_SET_EMPLOYEE_COLUMNS_WIDTH:
    return {
      ...state,
      eColumnsWidth: {
        ...state.eColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_EMPLOYEE_COLUMNS_SEQUENCE:
    // console.log(action.payload);

    return {
      ...state,
      eColumnsSequence: [...action.payload]
    };
  case APP_SET_EMPLOYEE_APPLICATION_COLUMNS_WIDTH:
    return {
      ...state,
      eaColumnsWidth: {
        ...state.eaColumnsWidth,
        ...action.payload
      }
    };
  case APP_SET_EMPLOYEE_APPLICATION_COLUMNS_SEQUENCE:
    return {
      ...state,
      eaColumnsSequence: [...action.payload]
    };
  default:
    return state;
  }
};
